var _defs, _path, _polyline, _path2, _ellipse, _path3, _line, _line2, _line3, _line4, _line5, _path4, _ellipse2, _path5, _line6, _line7, _line8, _line9, _line10, _path6, _ellipse3, _path7, _line11, _line12, _line13, _line14, _line15, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse4, _path15, _line16, _line17, _line18, _line19, _line20, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResumeTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#0b1320;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:none;stroke-dasharray:2.39 3.98;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.67,168.34V143a4.64,4.64,0,0,1,4.64-4.64H235.76V78.87H5v134a4.64,4.64,0,0,0,4.64,4.64H231.11a4.65,4.65,0,0,0,4.65-4.64V173H22.31A4.65,4.65,0,0,1,17.67,168.34Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5 148.22 5 113.55 235.76 113.55 235.76 138.31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.57,104.42a8.21,8.21,0,1,1,8.06-8.21A8.14,8.14,0,0,1,30.57,104.42Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 30.57,
    cy: 94.57,
    rx: 3.22,
    ry: 3.28
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.57,104.42a8,8,0,0,0,5.69-2.4,6,6,0,0,0-11.39,0A8,8,0,0,0,30.57,104.42Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 93.79,
    x2: 57.65,
    y2: 93.79
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 98.63,
    x2: 53.07,
    y2: 98.63
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.33,
    y1: 96.21,
    x2: 112.83,
    y2: 96.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.82,
    y1: 96.21,
    x2: 160.46,
    y2: 96.21
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.18,
    y1: 96.21,
    x2: 210.81,
    y2: 96.21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.4,137.91a8.16,8.16,0,1,1,12.23-7,8.23,8.23,0,0,1-4,7.1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 30.57,
    cy: 129.25,
    rx: 3.22,
    ry: 3.28
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.17,138.23a8.13,8.13,0,0,0,2.09-1.54,6,6,0,0,0-11.39,0,7.91,7.91,0,0,0,2.27,1.62"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 128.47,
    x2: 57.65,
    y2: 128.47
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 133.31,
    x2: 53.07,
    y2: 133.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.33,
    y1: 130.89,
    x2: 112.83,
    y2: 130.89
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.82,
    y1: 130.89,
    x2: 160.46,
    y2: 130.89
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.18,
    y1: 130.89,
    x2: 210.81,
    y2: 130.89
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.57,208.44a8.21,8.21,0,1,1,8.06-8.2A8.13,8.13,0,0,1,30.57,208.44Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 30.57,
    cy: 198.6,
    rx: 3.22,
    ry: 3.28
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.57,208.44a7.93,7.93,0,0,0,5.69-2.4,6,6,0,0,0-11.39,0A7.94,7.94,0,0,0,30.57,208.44Z"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 197.82,
    x2: 57.65,
    y2: 197.82
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.39,
    y1: 202.66,
    x2: 53.07,
    y2: 202.66
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.33,
    y1: 200.24,
    x2: 112.83,
    y2: 200.24
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 126.82,
    y1: 200.24,
    x2: 160.46,
    y2: 200.24
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 171.18,
    y1: 200.24,
    x2: 210.81,
    y2: 200.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.67,148.23H5V182.9H235.76V173H22.31a4.65,4.65,0,0,1-4.64-4.65V148.23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.76,56.53a4.09,4.09,0,0,0-4.09-4.08H9.08A4.08,4.08,0,0,0,5,56.53V78.87H235.76ZM21.13,69.44a3.78,3.78,0,1,1,3.78-3.78A3.78,3.78,0,0,1,21.13,69.44Zm14.05,0A3.78,3.78,0,1,1,39,65.66,3.78,3.78,0,0,1,35.18,69.44Zm14,0A3.78,3.78,0,1,1,53,65.66,3.78,3.78,0,0,1,49.23,69.44Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.13,61.88a3.78,3.78,0,1,0,3.78,3.78A3.79,3.79,0,0,0,21.13,61.88Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.18,61.88A3.78,3.78,0,1,0,39,65.66,3.79,3.79,0,0,0,35.18,61.88Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.23,61.88A3.78,3.78,0,1,0,53,65.66,3.78,3.78,0,0,0,49.23,61.88Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.79,138.31H22.31A4.64,4.64,0,0,0,17.67,143v25.39A4.65,4.65,0,0,0,22.31,173H243.79a4.65,4.65,0,0,0,4.64-4.65V143A4.64,4.64,0,0,0,243.79,138.31Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.24,163.85a8.21,8.21,0,1,1,8.06-8.2A8.13,8.13,0,0,1,43.24,163.85Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 43.24,
    cy: 154.01,
    rx: 3.22,
    ry: 3.28
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.24,163.85a8,8,0,0,0,5.69-2.39,6,6,0,0,0-11.38,0A8,8,0,0,0,43.24,163.85Z"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.06,
    y1: 153.23,
    x2: 70.32,
    y2: 153.23
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 55.06,
    y1: 158.07,
    x2: 65.74,
    y2: 158.07
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100,
    y1: 155.65,
    x2: 125.51,
    y2: 155.65
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 139.49,
    y1: 155.65,
    x2: 173.13,
    y2: 155.65
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 183.85,
    y1: 155.65,
    x2: 223.48,
    y2: 155.65
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "243.81 186.13 239.53 153.19 265 172.8 252 174.49 243.81 186.13"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeTracking);
export default __webpack_public_path__ + "static/media/resume_tracking.ac2e8a9ebc5923e836118287473e25ea.svg";
export { ForwardRef as ReactComponent };